export const T1D_RELATIONSHIPS = [
  "I live with T1D",
  "I am the parent/caregiver of a T1D",
  "My spouse/partner lives with T1D",
  "My sibling lives with T1D",
  "Other family member lives with T1D",
  "I am a friend of someone living with T1D",
  "I am a healthcare professional (Doctor, Nurse, CDE, Researcher)",
  "I work in the T1D industry (Device/Pharma/etc.)",
  "I am a supporter/ally of the T1D community (no direct personal connection)",
] as const;

export const REFERRAL_SOURCES = [
  "Friend or family",
  "Social media",
  "Email or newsletter",
  "QR code or flyer at an event",
  "Warrior Volunteer site",
  "Other",
] as const;
